module.exports = __webpack_public_path__ + "static/img/henwen.5c9a0d7d.svg";